// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Malta from '../_raw/flag/icon_flag_malta.png';

export default () => <img src={Malta} alt="Malta" />;
